import React from "react";
import Select from "react-select";
import { DatePicker } from "rsuite";

import PageTitle from "../../layouts/PageTitle";
import BlogCategory from "../cms/BlogCategory";

const options = [
  { value: "1", label: "Gender" },
  { value: "2", label: "Male" },
  { value: "3", label: "Female" },
];

const options1 = [
  { value: "1", label: "Department" },
  { value: "2", label: "React" },
  { value: "3", label: "CSS" },
  { value: "4", label: "JavaScript" },
  { value: "4", label: "Angular" },
  { value: "4", label: "HTML" },
  { value: "4", label: "VueJs" },
  { value: "4", label: "Ruby" },
  { value: "4", label: "PHP" },
  { value: "4", label: "ASP.NET" },
  { value: "4", label: "Python" },
  { value: "4", label: "MySQL" },
];

const AddBlogCategory = () => {
  return (
    <>
      <PageTitle
        activeMenu={"Add Blog Categor"}
        motherMenu={"Blog Categories"}
      />
      <BlogCategory />
    </>
  );
};

export default AddBlogCategory;
